<div class="footer">
  <span class="color-blue-dark" *ngIf="branchName">{{ branchName }}</span>
</div>
